/*
  •	Copyright (c) 2023 Pegasystems Inc.
  •	All rights reserved.
*/
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { logAndCatchError } from '../../utils/rxjs-utils';
import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import * as actionType from '../../store/state/actions';
import { processHeaders } from '../../store/state/epics/util';
import HeaderProcessor from '../../service_broker/header-processor';
import ObjectTransformer from '../../utils/object-transformer';
import EnvironmentInfo from '../../environment-info';

const OPEN_WORK_BY_HANDLE_DXAPI_LOG_ERROR_MESSAGE = 'Error occurred during ajax call at openWorkByHandle Epic : ';

export const executeOpenWorkByHandleRequest = (
  actionInPayload: {
    pageName?: string;
    insKey?: string;
    headers?: Record<string, string>;
    context?: string;
    debugInfo?: Record<string, unknown>;
    viewType?: string;
  },
  options: { removeActionPayload?: Record<string, string | number | boolean> }
) => {
  const { insKey, headers, context, debugInfo, viewType } = actionInPayload;
  const { removeActionPayload } = options;
  const pageName = actionInPayload?.pageName ? actionInPayload?.pageName : EnvironmentInfo.getDefaultCasePage();
  const restApiDetails = resolveRestApi(actionType.ACTION_OPENWORKBYHANDLE, {
    caseID: insKey,
    params: { pageName }
  });
  let { restApi } = restApiDetails;
  const { reqType } = restApiDetails;
  if (viewType === 'none') {
    restApi = `${restApi?.split('viewType')[0]}viewType=none`;
  }

  return from(
    fetch(
      restApi,
      {
        method: reqType,
        headers: {
          ...headers,
          ...(debugInfo && { ...HeaderProcessor.addDebugHeaders(debugInfo) })
        }
      },
      context
    )
  ).pipe(
    map((response) => {
      ObjectTransformer.analyseResponse(response);
      return {
        response: response.data,
        actionInPayload,
        headers: processHeaders({ ...headers, ...response.headers }),
        removeActionPayload
      };
    }),
    logAndCatchError(OPEN_WORK_BY_HANDLE_DXAPI_LOG_ERROR_MESSAGE, context)
  );
};

export default executeOpenWorkByHandleRequest;
